import { render, staticRenderFns } from "./ExamPreview.vue?vue&type=template&id=324ba0f3&scoped=true"
import script from "./ExamPreview.vue?vue&type=script&lang=js"
export * from "./ExamPreview.vue?vue&type=script&lang=js"
import style0 from "./ExamPreview.vue?vue&type=style&index=0&id=324ba0f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ba0f3",
  null
  
)

export default component.exports